import { RadioGroup as MuiRadioGroup, RadioGroupProps as MuiRadioGroupProps } from '@mui/material';
import clsx from 'clsx';
import { Radio } from 'components/Form/Radio/Radio';
import React from 'react';
import { Option } from 'types/Generics';

import classes from './RadioGroup.module.scss';

interface RadioGroupProps<T> extends Omit<MuiRadioGroupProps, 'onChange'> {
    label?: string;
    options: Array<Option<T>>;
    onChange?: (value: Option<T>) => void;
}

export const RadioGroup = <T,>({
    label,
    options,
    className,
    onChange,
    ...props
}: RadioGroupProps<T>) => {
    const onChangeHandler = (e: React.ChangeEvent<HTMLInputElement>, value: string) => {
        const selectedOption = options.find(opt => String(opt.id) === value);

        if (selectedOption) {
            onChange?.(selectedOption);
        }
    };

    return (
        <div className={clsx(classes.root, className)}>
            {label && <p className={classes.label}>{label}</p>}

            <MuiRadioGroup {...props} onChange={onChangeHandler} className={clsx(classes.group)}>
                {options.map((opt, i) => (
                    <Radio key={i} label={opt.name} value={opt.id} />
                ))}
            </MuiRadioGroup>
        </div>
    );
};
